import { PostContent } from '@3m5/sm_publish-frontend-api/models'
import { PostingTemplate } from '@professocial/professocialTypes/types/commonTypes'

const clearTemplate = (posting: PostingTemplate) => {
  const clearedTemplate: PostingTemplate = { ...posting }
  const newContent: PostContent = { text: clearedTemplate.content.text, extensions: {} }
  if (clearedTemplate.content.image?.url) {
    newContent.image = clearedTemplate.content.image
  }
  if (clearedTemplate.content.video?.url) {
    newContent.video = clearedTemplate.content.video
  }
  if (clearedTemplate.content.link?.url) {
    newContent.link = clearedTemplate.content.link
  }
  clearedTemplate.content = newContent
  return clearedTemplate
}

export default clearTemplate
